import React from "react"
import icons1 from '../../pageComponents/images/page13/icons1-page13.svg'
import icons2 from '../../pageComponents/images/page13/icons2-page13.svg'
import number4 from '../../pageComponents/images/page13/number-4.svg'
import number5 from '../../pageComponents/images/page13/number-5.svg'
import number6 from '../../pageComponents/images/page13/number-6.svg'
import icon4 from '../../pageComponents/images/page13/icon4.svg'
import icon5 from '../../pageComponents/images/page13/icon5.svg'
import icon6 from '../../pageComponents/images/page13/icon6.svg'
import frecciaOrange from '../../pageComponents/images/freccia-orange.svg'

const Page13Mobile = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="grid-cols-4 md:grid-cols-8">
      <div className='col-4 md:col-6 md:col-offset-left-1'>
        <div className='mt-5 mb-5 barra-arancio'></div>
        <div className='md:d-flex md:justify-content-center'>
          <div className='md:mr-1'>
            <img src={number4} alt='Number 4' />
          </div>
          <div className='mt-1 d-flex align-items-center'>
            <div className='font-16 line-height-20'>
              <strong>Topografia.</strong>Il percorso<br />incide sull’autonomia:<br /> guidare in salita, per<br />esempio, riduce del 60<br />
              per cento le prestazioni.
            </div>
            <div className='ml-3'>
              <img src={icon4} alt='Icon 4' height='30' />
            </div>
          </div>
        </div>
        <div className='mt-4 md:d-flex md:justify-content-center'>
          <div className='md:mr-1'>
            <img src={number5} alt='Number 5' />
          </div>
          <div className='mt-1 d-flex align-items-center'>
            <div className='font-16 line-height-20'>
              <strong>Peso.</strong> Il peso trasportato<br />(persone e/o attrezzature)<br />può ridurre l'autonomia<br />
              di un veicolo elettrico fino <br />
              al 20 per cento.
            </div>
            <div className='ml-3'>
              <img src={icon5} alt='Icon 5' height='39' />
            </div>
          </div>
        </div>
        <div className='mt-4 md:d-flex md:justify-content-center'>
          <div className='md:mr-1'>
            <img src={number6} alt='Number 6' />
          </div>
          <div className='mt-1 d-flex align-items-center'>
            <div className='font-16 line-height-20'>
              <strong>Meteo.</strong> L'impatto delle<br />condizioni atmosferiche<br />
              su un e-vehicle può essere<br />rilevante se non calcolato<br />nel modo corretto.
            </div>
            <div className='ml-3'>
              <img src={icon6} alt='Icon 6' height='38' />
            </div>
          </div>
        </div>
        <div className='mt-5 mb-5 barra-arancio'></div>
        <div>
          <div className='d-flex'>
            <div className='title-rectangle'></div>
            <div className='ml-1 line-height-20 font-16'>Report</div>
          </div>
          <div className='mt-2 font-family-acumin font-22 line-height-28 font-weight-500'>
            Edison fornisce un report dettagliato con tutte le
            informazioni necessarie per lanciare l’intero processo
            di elettrificazione della flotta.
          </div>
          <div className='mt-2 font-16 line-height-20'>
            Al termine del monitoraggio della flotta, Edison aiuta l’azienda a
            dimensionare correttamente la propria flotta, a risolvere
            le inefficienze, a ripartire correttamente le infrastrutture di
            ricarica tra le sedi, e a conoscere il risparmio previsto.
          </div>
          <div className='mt-4 text-center'>
            <img src={icons1} alt='Icons' />
          </div>
        </div>
        <div className='mt-5 mb-5 barra-arancio'></div>
        <div>
          <div className='d-flex'>
            <div className='title-rectangle'></div>
            <div className='ml-1 line-height-20 font-16'>Risultati</div>
          </div>
          <div className='text-center'>
            <img src={icons2} alt='Icons' />
          </div>
          <div className='mt-2 font-16 line-height-20'>
            Quali sono i vantaggi di Edison Fleet Audit?
          </div>
          <div className='mt-2 d-flex font-16 line-height-20'>
            <div><img src={frecciaOrange} alt='Freccia orange' /></div>
            <div style={{ width: '90%' }} className='ml-2'>
              È un servizio innovativo e sostenibile in un mercato,
              quello dell’elettrico, sempre più in espansione.
            </div>
          </div>
          <div className='mt-2 d-flex font-16 line-height-20'>
            <div><img src={frecciaOrange} alt='Freccia orange' /></div>
            <div style={{ width: '90%' }} className='ml-2'>
              È un modo per migliorare l'efficienza
              complessiva della propria flotta aziendale.
            </div>
          </div>
          <div className='mt-2 d-flex font-16 line-height-20'>
            <div><img src={frecciaOrange} alt='Freccia orange' /></div>
            <div style={{ width: '90%' }} className='ml-2'>
              È una soluzione che consente di risparmiare,
              grazie anche agli incentivi sulle auto elettriche.
            </div>
          </div>
          <div className='mt-2 mb-2 d-flex font-16 line-height-20'>
            <div><img src={frecciaOrange} alt='Freccia orange' /></div>
            <div style={{ width: '90%' }} className='ml-2'>
              È un’importante leva di comunicazione
              e marketing per l’azienda e la sua immagine green.
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page13Mobile
